var styles = {"box":"Header_box_17awr_1","left":"Header_left_17awr_16","menu-btn":"Header_menu-btn_17awr_23","logo-desktop":"Header_logo-desktop_17awr_28","logo-mobile":"Header_logo-mobile_17awr_33","center":"Header_center_17awr_47","gradient":"Header_gradient_17awr_38","right":"Header_right_17awr_57","isAuthUser":"Header_isAuthUser_17awr_102"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
